import { Injectable } from '@angular/core';
import { UCMForm } from '@tmhcc-ng-lib/data-service';
import { hasValue } from '@tmhcc/util';
import { Observable, of } from 'rxjs';
import { concatMap, map } from 'rxjs/operators';

@Injectable()
export class UCMSharedService {
  constructor() {}

  getUCMPageId(
    ucmDetails: UCMForm[],
    formName: string,
    tabName: string = null
  ) {
    if (ucmDetails && ucmDetails.length > 0) {
      let ucmForm: UCMForm;
      if (hasValue(formName) && hasValue(tabName)) {
        ucmForm = ucmDetails.find(
          ucm => ucm.formName === formName && ucm.tabName === tabName
        );
      } else if (hasValue(formName)) {
        ucmForm = ucmDetails.find(ucm => ucm.formName === formName);
      }

      return ucmForm.formID || 0;
    } else {
      throw new Error('No form page has been setup in sitecore.');
    }
  }
}
